import { render, staticRenderFns } from "./MiddleNotice.vue?vue&type=template&id=f11f2f64&scoped=true&"
import script from "./MiddleNotice.vue?vue&type=script&lang=js&"
export * from "./MiddleNotice.vue?vue&type=script&lang=js&"
import style0 from "./MiddleNotice.vue?vue&type=style&index=0&id=f11f2f64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11f2f64",
  null
  
)

export default component.exports